import store from '@/store'
import CryptoJS from 'crypto-js'

//科学计数法
function toNumberStr(num) {
	var number = Number(num);
	var n = number.toFixed(10) + "";
	var len = n.length;
	var rn = "";
	var start = true;

	if((n.indexOf("e") >= 0 || n.indexOf("E") >= 0) && n.indexOf("-") >= 0){
		var loc = n.indexOf("e");
		var lnStr = n.substring(loc + 2, n.length);
		if(!isNaN(lnStr)){
			var nn = n.substring(0, loc); 
			var ln = parseInt(lnStr);
			for(var k = 0; k < ln; k++){
				if(k == ln - 1){
					nn = "0." + nn;
				}else{
					nn = "0" + nn;
				}
			}
			n = nn + "0";
			len = n.length;
		}
	}
	rn = n;
	for(var y = len; y > 0; y--){
		if(n.charAt(y - 1) == "0" && start){
			rn = n.substring(0, y-1);
		}else if(n.charAt(y - 1) != "0" && start){
			start = false;
		}else{
			start = false;
		}
		if(rn.lastIndexOf(".") == rn.length - 1){
			rn = rn.substring(0, rn.length - 1) + "";
			return rn;
		}
	}
	return rn;
};

// aes加解密
var aesUtil = {

  //获取key，
  genKey : function (length = 16) {
      let random = "rcygrcygrcygrcyg";
      // let str = "";
      // for (let i = 0; i < length; i++) {
      //     str  = str + random.charAt(Math.random() * random.length)
      // }
      return random;
  },
	//获取key，
  duanxinKey : function (length = 16) {
      let random = "duanxinqianfeile";
      return random;
  },
  //加密
  encrypt : function (plaintext,key) {
      if (plaintext instanceof Object) {
          //JSON.stringify
          plaintext = JSON.stringify(plaintext)
      }
      let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), CryptoJS.enc.Utf8.parse(key), {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
      return encrypted.toString();
  },

  //解密
  decrypt : function (ciphertext,key) {
      let decrypt = CryptoJS.AES.decrypt(ciphertext.toString(CryptoJS.enc.Utf8), CryptoJS.enc.Utf8.parse(key), {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
      let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString();
      if(decString.charAt(0) === "{" || decString.charAt(0) === "[" ){
          //JSON.parse
          decString = JSON.parse(decString);
      }
      return decString;
  }
};

//** oss全局默认图片
function defaultImg(imgUrl) {
	// let defaultUrl= 'https://rongchengyigou-dev.oss-cn-chengdu.aliyuncs.com/systemIcon/other/d-cover.jpg';
	let defaultUrl= '../assets/image/bg.jpg';
	if(!imgUrl) { return defaultUrl }
	let arr= ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'];
	let index= imgUrl.lastIndexOf(".");
	let ext = imgUrl.substr(index+1);
	if(arr.indexOf(ext)==-1) {
		return defaultUrl
	}else{
		return imgUrl
	}
}
export default {
	toNumberStr,
	defaultImg,
	aesUtil
}



// WEBPACK FOOTER //
// ./src/utils/utilsFun.js